import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import _ from "lodash"
import "../index.css"

//Inputs
import { Button, TextInputField } from "../helpers";
import { ThreeDots } from "react-loader-spinner";

// redux
import { raiseToast } from "../services/redux/reducers/toast/toast";

// apis
import { getMaterialMasterBySearchText } from "../services/api/materialMaster";


const MaterialSearch = (props) => {
    const dispatch = useDispatch()
    const { selectedMaterialItemIds } = props

    const [productSearch, setProductSearch] = useState('')
    const [selectedProducts, setSelectedProducts] = useState([])
    const [materialSearchLoading, setMaterialSearchLoading] = useState(false)

    const handleInputSearchChange = async (e) => {
        setProductSearch(e.target.value)
        handleMaterialMasterDebounceSearch(e.target.value)
    }

    const handleMaterialMasterDebounceSearch = useCallback(_.debounce(async function (searchText) {
        setMaterialSearchLoading(true)
        if(!searchText){
            setSelectedProducts([])
            setMaterialSearchLoading(false)
            return
        }

        let data = {
            searchText
        }

        const materialMasterSearchResponse = await getMaterialMasterBySearchText(data)
        console.log("materialMasterSearch - Response",materialMasterSearchResponse)

        if(materialMasterSearchResponse.failure){
            dispatch(raiseToast({severity:'error', detail: materialMasterSearchResponse?.data?.error, life: 3000}))
        }else{
            setSelectedProducts(materialMasterSearchResponse?.data)
        }

        setMaterialSearchLoading(false)
    }, 1000), [])

    const handleAddClick = (selectedMaterialItem) => {
        props.handleSelectedMaterialItem(selectedMaterialItem)
    }
    
    return(
        <div className='flex flex-column add-rc-product'>
            <div className='flex flex-column col-12 px-0'>
                <label htmlFor="searchProducts" className="text-sm">Search Product / Specification / Material Code</label>
                <TextInputField name="" value={productSearch} labelText="" id="searchProducts" onChange={e => handleInputSearchChange(e)} />
            </div>
            <div className="rc-products-container mb-2">
                {
                    materialSearchLoading ? 
                        <div className="flex justify-content-center align-items-center h-full">
                            <ThreeDots height="50" width="50" radius="5"color="#00baac" ariaLabel="three-dots-loading" visible={true} /> 
                        </div> 
                    :
                    selectedProducts?.length === 0 ? 
                        <p className="flex justify-content-center text-2xl font-medium" style={{color: '#495057'}}>
                            {productSearch ? 'No products found' : 'Please search for products'}
                        </p> 
                        :
                        selectedProducts?.map(eachProduct => {
                            return (
                                <div key={`material-${eachProduct.materialId}`} className="flex justify-content-between align-items-center pl-3 product-item">
                                    <p>{eachProduct?.materialId} | {eachProduct?.productName} | {eachProduct?.productSpecification} |{eachProduct?.listPrice}</p>
                                    <Button label={selectedMaterialItemIds.includes(eachProduct.materialId) ? "Added" : "Add"} className="w-1 h-2rem mr-2" onClick={() => handleAddClick(eachProduct)} disabled={selectedMaterialItemIds.includes(eachProduct.materialId) ? true : false} />
                                </div>
                            )
                        })
                }
            </div>
        </div>
    )
}

export default MaterialSearch